import { cx } from '@linaria/core';
import { jsx } from 'react/jsx-runtime';

const className = "dibc1ls4eti";
function SVG(props) {
  return /*#__PURE__*/jsx("svg", {
    ...props,
    className: cx(className, props.className)
  });
}

export { SVG, className };
import "./style.svg.linaria.module.css";
//# sourceMappingURL=style.svg.js.map
